import ApiFetcher2 from 'static/three-oh/src/modules/apis/ApiFetcher2';

class LicenseApi {
  static getForCurrentUser() {
    return ApiFetcher2.get('user/me/license/');
  }
}

export default LicenseApi;
